interface StepperProps {
  total: number;
  /** 1-based current step; segments < current are "on" */
  current: number;
  /** show the "NN / MM" mono counter */
  showCount?: boolean;
  className?: string;
}

export function Stepper({ total, current, showCount = true, className }: StepperProps) {
  return (
    <div className={["stepper", className].filter(Boolean).join(" ")} role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={current} aria-label="手順の進捗">
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={`seg${i < current ? " on" : ""}`} />
      ))}
      {showCount ? (
        <span className="mono" style={{ marginLeft: 8 }}>
          {String(current).padStart(2, "0")} / {String(total).padStart(2, "0")}
        </span>
      ) : null}
    </div>
  );
}
